export default __webpack_public_path__ + "static/media/Notif_Bubble.d80187c7.mp3";